module.exports = __webpack_public_path__ + "animationpaths/e8ab75f36071cf14478163ae045f5a12.data";